// extracted by mini-css-extract-plugin
export default {"workerCards":"WorkerReassign_workerCards__KYWpR"};